// extracted by mini-css-extract-plugin
module.exports = {"benefitsContainer":"Benefits_benefitsContainer__EWzVx","titleDescription":"Benefits_titleDescription__21gOb","text":"Benefits_text__3F49P"};